import { render, staticRenderFns } from "./SellerSelector.vue?vue&type=template&id=45bf29b0&"
import script from "./SellerSelector.vue?vue&type=script&lang=js&"
export * from "./SellerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports